
























































































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { Location } from "vue-router";
import _ from "lodash";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import Button from "@/shared/components/ui/Button.vue";
import Input from "@/shared/components/ui/Input.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import {
  OktaCredential,
  Home
} from "@/employee/route-names";
import moment from "moment";
import { oktaForgotUsername } from "../api/userService";
import {
  ForgotUsernameResponseModel,
  ThemeGetRequest
} from "../types";
import { formatDateString } from "@/shared/dateString";
import { ForgotUsernameResources } from "@/shared/forgotUsernameResources";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useThemeStore } from "@/shared/store/theme";
import { useCredentialFlowStore } from "@/employee/store/credentialFlow";

@Component({
  components: {
    LoginWrapper,
    Button,
    Input,
    GenericLoadingSpinner
  },
  props: {
    routeToOktaLogin: null,
    header: {
      type: String,
      default: ForgotUsernameResources.ForgotUsernameHeader
    },
    description: {
      type: String,
      default: ForgotUsernameResources.ForgotUsernameDescription
    }
  }
})
export default class LoginForgotUsername extends Vue {
  $validator: Validator;
  notifierStore = useNotifierStore();
  userStore = useUserStore();
  portalCustomizationStore = usePortalCustomizationStore();
  themeStore = useThemeStore();
  credentialFlowStore = useCredentialFlowStore();


  formatDateString = formatDateString;
  isSubmitting = false;
  emailSentMessage = false;
  multipleAccountExists = false;
  accounts: ForgotUsernameResponseModel[];
  routeToOktaLogin: Location;
  dateOfBirth = "";
  zipCode = "";
  last4Ssn = "";
  username = "";
  header: string;
  description: string;

  mounted () {
    const partnerId = (this.$route.query && this.$route.query.partnerid) ?
        this.$route.query.partnerid : this.portalCustomizationStore.partnerId;
    const parsedPartnerId = _.toSafeInteger(partnerId);

    if (parsedPartnerId) {
      this.themeStore.getTheme({ partnerId: parsedPartnerId, employerId: 0, forceUpdate: true });
    }
  }

  onSubmit () {
    if (this.isSubmitting) return;

    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      this.onValidSubmit();
    });
  }

  onValidSubmit () {
    this.isSubmitting = true;
    return oktaForgotUsername({
      dateOfBirth: moment(this.dateOfBirth).format("YYYY-MM-DD"),
      zip: this.zipCode,
      lastFourSsn: this.last4Ssn,
      username: this.username
    })
        .then(resp => {
          if (resp.data.sendToCredentialingFlow) {
            this.credentialFlowStore.setCredentialFlowUsername(resp.data.records[0].username);
            this.$router.push({
              name: OktaCredential,
              params: { zipCode: this.zipCode, dateOfBirth: this.dateOfBirth }
            });
          }

          if (resp.data.multipleAccountExists) {
            this.isSubmitting = false;
            this.multipleAccountExists = true;
            this.accounts = _.orderBy(
                resp.data.records,
                [
                  // null dateAccountOpened should be at the last
                  r => r.dateAccountOpened ? 1 : 0,
                  "dateAccountOpened"
                ],
                [ "desc" ]);
            return;
          }

          this.$nextTick(() => {
            this.emailSentMessage = true;
            this.isSubmitting = false;
          });
        })
        .catch(error => {
          this.onError(error);
        });
  }

  onError (error: any) {
    this.isSubmitting = false;
    this.notifierStore.error({ error, rethrow: false });
  }

  onAccountSelect (username) {
    this.username = username;
    this.onValidSubmit();
  }

  formatDate (date?: string) {
    if (!date) {
      return "";
    }

    return formatDateString(date);
  }

  get submitDisabled () {
    return this.isSubmitting === true;
  }
}
